import React from 'react';
import { Database, Layers, Tag, Gauge, Network, Activity } from 'lucide-react';
import GraphCanvasShell from './GraphCanvasShell';

function WorkflowStats({ datasourceCount, datasetCount, attributeCount }) {
    return (
        <div className="lin-stats">
            <span className="lin-stat">
                <span className="ic"><Database size={15} /></span>{' '}
                Datasource: <b>{datasourceCount}</b>
            </span>
            <span className="lin-stat">
                <span className="ic"><Layers size={15} /></span>{' '}
                Datasets: <b>{datasetCount}</b>
            </span>
            <span className="lin-stat">
                <span className="ic"><Tag size={15} /></span>{' '}
                Attributes: <b>{attributeCount}</b>
            </span>
            <span className="lin-stat">
                <span className="ic"><Gauge size={15} /></span>{' '}
                KPI: <b>1</b>
            </span>
        </div>
    );
}

export default class WorkflowModal extends React.Component {
    render() {
        const { show, onClose, row = {} } = this.props;
        if (!show) return null;

        const kpiName = row.kpiName || 'KPI';
        const datasetName = row.assetName || row.dataset || '—';
        const attribute = row.attributeName || row.attribute || '—';
        const formula = row.formula || '—';
        const datasource = row.datasourceName || row.datasource || '—';

        const datasourceCount = datasource && datasource !== '—' ? 1 : 0;
        const datasetCount = datasetName && datasetName !== '—' ? 1 : 0;
        const attributeCount = attribute && attribute !== '—' ? 1 : 0;

        return (
            <GraphCanvasShell
                show={show}
                onClose={onClose}
                defaultTheme="light"
                title={(
                    <>
                        <span className="k"><Gauge size={18} /> KPI:</span>{' '}{kpiName}
                    </>
                )}
                stats={(
                    <WorkflowStats
                        datasourceCount={datasourceCount}
                        datasetCount={datasetCount}
                        attributeCount={attributeCount}
                    />
                )}
                legend={(
                    <div className="lin-legend">
                        <span className="lg"><span className="sw sw-i"></span> KPI · target</span>
                        <span className="lg"><span className="sw sw-n"></span> Mapped assets</span>
                    </div>
                )}
            >
                <svg
                    className="lin-edges"
                    viewBox="0 0 1320 780"
                    preserveAspectRatio="none"
                    style={{ width: '1320px', height: '780px' }}
                >
                    <path className="ed-ind" d="M250 360 C300 360,285 360,330 360" />
                    <path className="ed-ind" d="M580 360 C665 360,650 360,730 360" />
                    <path className="ed-ind" d="M980 360 C1035 360,1040 355,1090 355" />
                </svg>

                <div className="card" style={{ left: 35, top: 315, width: 215, position: 'absolute' }}>
                    <div className="c-head">
                        <span className="c-ico"><Database size={13} /></span>
                        <span className="c-name">{datasource}</span>
                        <span className="c-type">Source</span>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Datasets</div>
                        <div className="c-item"><span className="fi"><Layers size={13} /></span>{datasetName}</div>
                    </div>
                </div>

                <div className="card" style={{ left: 330, top: 260, width: 250, position: 'absolute' }}>
                    <div className="c-head">
                        <span className="c-ico"><Layers size={13} /></span>
                        <span className="c-name">{datasetName}</span>
                        <span className="c-type">Dataset</span>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Attributes</div>
                        <div className="c-item"><span className="fi"><Tag size={13} /></span>{attribute}</div>
                    </div>
                </div>

                <div className="card" style={{ left: 730, top: 260, width: 250, position: 'absolute' }}>
                    <div className="c-head">
                        <span className="c-ico"><Network size={13} /></span>
                        <span className="c-name">Mapped field</span>
                        <span className="c-type">Attribute</span>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Field</div>
                        <div className="c-item"><span className="fi"><Tag size={13} /></span>{attribute}</div>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Source</div>
                        <div className="c-item"><span className="fi"><Activity size={13} /></span>{datasource}</div>
                    </div>
                </div>

                <div className="card kpi" style={{ left: 1090, top: 305, width: 230, position: 'absolute' }}>
                    <div className="c-head">
                        <span className="c-ico"><Gauge size={13} /></span>
                        <span className="c-name">{kpiName}</span>
                        <span className="c-badge">MAIN KPI</span>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Mapped attribute</div>
                        <div className="c-item"><span className="fi"><Tag size={13} /></span>{attribute}</div>
                    </div>
                    <div className="c-sec">
                        <div className="c-sec-lbl">Formula</div>
                        <div className="c-formula">{formula}</div>
                    </div>
                </div>
            </GraphCanvasShell>
        );
    }
}
